const costCenter = {
  validHeader: {
    'BU CODE*': 'bu_code',
    'BU DESC': 'bu_desc',
    'COST CENTER*': 'cost_center',
    SECTOR: 'sector',
  },
};
module.exports = { costCenter };
